/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "ui/feature/piece-play/common/piece-renderer/PieceRendererStepThruCurrentPlaceMarker.module.scss";

interface Props {
    currTime: number;
    maxTime: number;
}


const PieceRendererStepThruCurrentPlaceMarker: React.FC<Props> = ({maxTime, currTime}) => {

    const leftPercent = React.useMemo(() => {
        return `${(currTime / maxTime) * 100}%`
    }, [maxTime, currTime]);

    return (
        <div style={{
            left: leftPercent
        }} className={styles.line}/>
    )
}

export default PieceRendererStepThruCurrentPlaceMarker;